import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Select from 'react-select';
import { differenceInMonths, format, addMonths } from 'date-fns';
// import Rectangle6 from '../../../images/adminConsole/Rectangle6.png';

const useStyles = makeStyles(theme => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },

    avatar: {
        width: '57px',
        borderRadius: '8px',
        // borderRadius: '100px',
    },
    selectBody: {
        width: 200,
    },
    // paper: {
    //     backgroundColor: theme.palette.background.paper,
    //     border: '2px solid #000',
    //     boxShadow: theme.shadows[5],
    //     padding: theme.spacing(2, 4, 3),
    // },
}));

export default function MonthSelector(props) {
    const classes = useStyles();
    const startingDate = '2022-07';
    const currentDate = format(new Date(), 'yyyy-MM');
    const diffrence = differenceInMonths(new Date(currentDate), new Date(startingDate));
    const [calendarOptions, setCalendarOptions] = React.useState([]);
    React.useEffect(() => {
        const options = [];
        let dateToUpdate = startingDate;
        for (let month = 0; month < diffrence; month++) {
            let dateToInsert = addMonths(new Date(dateToUpdate), 1);
            options.push({
                label: format(dateToInsert, 'MMMM yyyy'),
                value: format(dateToInsert, 'yyyy-MM'),
            });
            dateToUpdate = dateToInsert;
        }
        setCalendarOptions(options);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (
        <div className={classes.selectBody}>
            <Select options={calendarOptions} {...props} />
        </div>
    );
}
